import {useEffect, useState} from "react";
import UploadPhoto from "../../component/UploadPhoto/UploadPhoto";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {MagazineService} from "../../serverService/magazineService/MagazineService";
import {useParams} from "react-router-dom";
import {
    RaikoBaseCardContainer, RaikoButtonPrimary, RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    showErrorMessage,
    showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";

export default function NewsDetailThumbnail() {

    const service = new MagazineService()

    const {id: blogID} = useParams()


    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof blogID !== "undefined" && blogID >= 0) {
            getNewsInfoFromServer()
        }
    }, [blogID])

    const [photoFile, setPhotoFile] = useState([]);
    const [photoUrl, setPhotoUrl] = useState([]);

    function getNewsInfoFromServer() {
        loading.show()
        service.getThumbnailInfo(blogID)
            .then(response => {
                if (response.downloadUrl && response.downloadUrl.length > 0) {
                    setPhotoUrl([response.downloadUrl])
                }
            }).catch(reason => {
            showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت تصویر شاخص"))
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateThumbnail() {
        if (photoFile && photoFile.length > 0) {
            loading.show()
            service.updateThumbnail(blogID, photoFile[0])
                .then(() => {
                    showSuccessMessage("تصویر شاخص با موفقیت بروزرسانی شد.")
                }).catch(reason => {
                showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در بروزرسانی تصویر شاخص"))
            }).finally(_ => {
                loading.hide()
            })
        } else {
            showWarningMessage("لطفا ابتدا فایل تصویر شاخص را انتخاب نمایید.")
        }
    }

    return (
        <RaikoBaseCardContainer>
            <RaikoGridOneColumn>
                <UploadPhoto
                    photoFile={photoFile}
                    setPhotoFile={setPhotoFile}
                    photo={photoUrl}
                    setPhoto={setPhotoUrl}
                />
                <RaikoFlexAlignEnd>
                    <RaikoButtonPrimary label={"بروزرسانی"} onClick={handleUpdateThumbnail}/>
                </RaikoFlexAlignEnd>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    )
}